import DifferenceDescription from '../DifferenceDescription/DifferenceDescription';
import { DifferenceProps } from '../DifferenceElementView';

const SpellingDifference = ({ difference, multipleSelectionMode = false }: DifferenceProps) => {
  return (
    <DifferenceDescription
      difference={difference}
      targetDescription={null}
      sourcePageNumberText={`identified new (p${difference.source.location.pageNumber})`}
      targetPageNumberText=""
      showExtra={false} // we dont use extra for spelling
      multipleSelectionMode={multipleSelectionMode}
    />
  );
};

export default SpellingDifference;
